const getSectionIds = (sectionsData) => sectionsData.keySeq();
const getSectionDataById = (sectionsData) => (id) => sectionsData.get(id);

export {getSectionIds, getSectionDataById}